var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1799_10364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98262 5.98825H2.98452V6.98629H3.98262V5.98825Z",
    fill: "#6B6C7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98072 5.98825H5.97881V6.98629H4.98072V5.98825Z",
    fill: "#6B6C7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.975 5.98825H6.97691V6.98629H7.975V5.98825Z",
    fill: "#6B6C7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9731 5.98825H9.9712V6.98629H8.9731V5.98825Z",
    fill: "#6B6C7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9674 5.98825H10.9693V6.98629H11.9674V5.98825Z",
    fill: "#6B6C7E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98452 7.98432H3.98262V8.98236H2.98452V7.98432Z",
    fill: "#6B6C7E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97881 7.98432H4.98072V8.98236H5.97881V7.98432Z",
    fill: "#6B6C7E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97691 7.98432H7.975V8.98236H6.97691V7.98432Z",
    fill: "#6B6C7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9712 7.98432H8.9731V8.98236H9.9712V7.98432Z",
    fill: "#6B6C7E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9693 7.98432H11.9674V8.98236H10.9693V7.98432Z",
    fill: "#6B6C7E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98262 9.9804H2.98452V10.9784H3.98262V9.9804Z",
    fill: "#6B6C7E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98452 11.9765H3.98262V12.9745H2.98452V11.9765Z",
    fill: "#6B6C7E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97881 11.9765H4.98072V12.9745H5.97881V11.9765Z",
    fill: "#6B6C7E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98072 9.9804H5.97881V10.9784H4.98072V9.9804Z",
    fill: "#6B6C7E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.975 9.9804H6.97691V10.9784H7.975V9.9804Z",
    fill: "#6B6C7E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9733 2.99411C15.0652 2.99411 15.951 3.87987 15.951 4.97148V12.9776L12.9567 15.9718H1.97764C0.885786 15.9718 0 14.9301 0 13.8384V4.97148C0 3.87987 0.885786 2.99411 1.97764 2.99411H1.98643V0.998037C1.98643 0.44601 2.43274 0 2.98452 0C3.53728 0 3.98262 0.44601 3.98262 0.998037V2.99411H6.97691V0.998037C6.97691 0.44601 7.42322 0 7.975 0C8.52777 0 8.9731 0.44601 8.9731 0.998037V2.99411H11.9674V0.998037C11.9674 0.44601 12.4137 0 12.9655 0C13.5182 0 13.9636 0.44601 13.9636 0.998037V2.99411H13.9733ZM11.9586 13.9726L13.9548 11.9765H11.9586V13.9726ZM13.9548 9.98043H9.96241V13.9726H2.0587C2.02744 13.9352 1.99619 13.8759 1.99619 13.8353V4.99021H13.9548V9.98043Z",
    fill: "#6B6C7E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1799_10364)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0008,
    height: 15.9998,
    fill: "#004DF0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/Icon-calendar.487789b088777e9af53cc02abd6da80a.svg";
export { ForwardRef as ReactComponent };